<template>
    <div>
      <div class="text-h5">
          <v-icon large>mdi-text-box-plus-outline</v-icon>ข้อมูลเพิ่มเติม
      </div>
        <v-list align="left" class="ml-4 mr-4 mb-4">
            <v-list-item
                v-for="(item, index) in group_extranote_list"
                :key="index"
            >
              <v-list>
                <v-card class="pa-2">
                <b class="ml-2">{{item.extranote_label}} : </b>
                <div class="d-flex" flat tile>
                <div
                    v-for="(item2, index2) in item.extranote_value"
                    :key="index2"
                    class="ml-2"
                >   
                    <v-text-field v-if="item2[0]=='{' && item2[item2.length-1]=='}'"
                        @change="(val)=>{changeExtranote(index,index2,val)}"
                        outlined
                        dense
                        :label="item2.substring(1,item2.length-1)"
                        hide-details
                    />
                    <div v-else-if="item2[0]=='[' && item2[item2.length-1]==']'">
                        <v-select
                            @change="(val)=>{changeExtranote(index,index2,val)}"
                            :items="item2.substring(1,item2.length-1).split(',')"
                            single-line
                            outlined
                            dense
                            hide-details
                        ></v-select>
                    </div>
                    <div v-else class="pa-2">{{item2}}</div>
                </div>
                <v-spacer></v-spacer>
                </div>
                </v-card>
            </v-list>
            </v-list-item>
        </v-list>

        <div align="center">
          <v-btn  color="#00E4FF" class="pa-5 text-h6 ma-2" width="80%" @click="submit">
            ยืนยันข้อมูล
          </v-btn>
        </div>

    </div>
</template>


<script>
import AppointmentSelection from '@/models/instance/AppointmentSelection.js'

export default {
  props: ['nextstep'],
  data () {
    return {
      group_extranote_list : []
      ,extranote_list:[]
    }
  },
  mounted : function () {
    JSON.parse(AppointmentSelection.getExtranote()).forEach(extranote=>{
        var vallist = []
        var old_vallist = []
        var tmp = ""
        for (const c of extranote.extranote_value){
            if(c=="["||c=="{"){
                if(tmp.length>0){
                    vallist.push(tmp)
                    old_vallist.push(tmp)
                    tmp = ""
                }
            }
            tmp = tmp + c                            
            if(c=="]"||c=="}"){
                if(tmp.length>0){
                    vallist.push(tmp)
                    old_vallist.push(tmp)
                    tmp = ""
                }
            }
        }
        if(tmp.length>0){
            vallist.push(tmp)
            old_vallist.push(tmp)
            tmp = ""
        }
        this.group_extranote_list.push({
            "extranote_name" : extranote.extranote_name
            ,"extranote_label" : extranote.extranote_label
            ,"extranote_value" : old_vallist
        })
        this.extranote_list.push({
            "extranote_name" : extranote.extranote_name
            ,"old_extranote_value" : old_vallist
            ,"extranote_value" : vallist
        })
    })
    AppointmentSelection.setExtranoteValue(JSON.stringify(this.extranote_list))
  },
  methods : {
    changeExtranote(extranote_index,value_index,value){
        var extranote_value = this.extranote_list[extranote_index].extranote_value
        extranote_value[value_index] = value
        if(value.length==0){
            extranote_value[value_index] = this.extranote_list[extranote_index].old_extranote_value[value_index]
        }
        this.extranote_list[extranote_index].extranote_value = extranote_value
    },
    submit(){
        var extranot_result = []
        this.extranote_list.forEach(exn=>{
            if(JSON.stringify(exn.old_extranote_value) != JSON.stringify(exn.extranote_value)){
                var isPass = true
                exn.extranote_value.forEach(v=>{
                    if((v[0]=='{' && v[v.length-1]=='}') || (v[0]=='[' && v[v.length-1]==']')){
                        isPass = false
                    }
                })
                if(isPass){
                    extranot_result.push({
                        "extranote_name" : exn.extranote_name
                        ,"extranote_value" : exn.extranote_value.join(' ')
                    })
                }
            }
        })
        AppointmentSelection.setExtranoteValue(JSON.stringify(extranot_result))
        this.nextstep()
    }
  },
}
</script>